import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';

const KeyProductFeatureName = (props) => {
  const { name, simple, inverseText, responsiveTileGrid } = props;
  const keyProductFeatureNameClasses = classNames('sui-flex', {
    'sui-w-full': responsiveTileGrid,
    'sui-w-1/2': !responsiveTileGrid,
  });
  return (
    <>
      {simple || inverseText ? (
        <>
          <div className={keyProductFeatureNameClasses}>
            <Typography truncate variant="body-xs" color="subtle">{name}</Typography>
          </div>
        </>
      ) : (
        <Typography variant="h4">{name}</Typography>
      )}
    </>
  );
};

KeyProductFeatureName.propTypes = {
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
  simple: PropTypes.bool,
  inverseText: PropTypes.bool,
  responsiveTileGrid: PropTypes.bool
};

KeyProductFeatureName.defaultProps = {
  name: null,
  simple: false,
  inverseText: false,
  responsiveTileGrid: false
};

export default KeyProductFeatureName;
